<template>
  <div class="tabs" :style="{ background: bgColor, borderColor: bdColor }">
    {{ value }}
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      defalut: '',
    },
    bgColor: {
      type: String,
      default: '',
    },
    bdColor: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.tabs {
  display: inline-block;
  padding: 3px 20px;
  background: #f6eadc;
  border-radius: 24px;

  font-size: 24px;

  font-weight: 400;
  color: #333333;
}
</style>
